import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

export function TrueOrFalseCell(props: GridRenderCellParams) {
  const { value } = props;
  if (value) {
    return <CheckIcon />;
  }

  return <ClearIcon />;
}
